import { useFormState } from 'components/elements/form';
import TableInput from 'components/elements/table/table-input';
import {
  ActionType,
  ColumnDataType,
  IColumn,
} from 'components/elements/table/type';
import { SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { onAddNewProductVariant } from '../../hooks/use-get-default-values';
import { ProductFormType, ProductVariantFormType } from '../form-type';

function useGetProductVariantTableList(): IColumn<ProductVariantFormType>[] {
  const { t } = useTranslation();
  const { editable } = useFormState();
  return [
    {
      header: t('common:variant'),
      accessorKey: 'name',
      minSize: 100,
      dataType: ColumnDataType.text,
      required: true,
    },
    {
      header: t('common:sell_price'),
      accessorKey: 'sellPrice',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
      required: true,
    },
    {
      header: t('common:description'),
      accessorKey: 'description',
      minSize: 100,
      dataType: ColumnDataType.text,
    },

    ...(editable
      ? [
          {
            header: '',
            accessorKey: 'delete',
            minSize: 60,
            size: 60,
            maxSize: 60,
            dataType: ColumnDataType.delete,
          },
        ]
      : [
          {
            header: t('common:stock'),
            accessorKey: 'stock',
            minSize: 200,
            dataType: ColumnDataType.number,
            minNumber: 0,
          },
        ]),
  ];
}
export default function ProductVariantTable() {
  const { editable } = useFormState();

  const {
    control,
    clearErrors,

    getValues,
    trigger,
  } = useFormContext<ProductFormType>();

  const columns = useGetProductVariantTableList();

  const name = 'productVariants' as const;
  const { fields, update, remove, append } = useFieldArray({
    control,
    name,
    keyName: '__customId',
  });

  const dispatch = React.useCallback(
    (action) => {
      const products = getValues(name);
      const currentRowIndex = action.rowIndex as number;
      const product = products[currentRowIndex];
      const type = action.type as ActionType;
      const columnId = action.columnId as keyof ProductVariantFormType;
      const value = action.value;
      // const extra = action.extra as Value;

      const otherVal: () => Partial<ProductVariantFormType> = () => {
        return {};
      };

      if (type === 'addRow') {
        append(onAddNewProductVariant());
        trigger(name);
      } else if (type === 'removeRow') {
        remove(currentRowIndex);
        trigger(name);
      } else if (type === 'update_cell') {
        update(currentRowIndex, {
          ...product,
          [columnId]: value,
          ...otherVal(),
        });
        clearErrors(`${name}.${currentRowIndex}.${columnId}`);
      }
    },
    [append, clearErrors, getValues, name, remove, trigger, update],
  );

  return (
    <div style={{ width: '100%' }}>
      <SeparatorVertical $margin={36} />
      <TableInput
        columns={columns}
        data={fields}
        dispatch={dispatch}
        disabled={!editable}
        name={name}
        uniqueRowKey="customId"
      />
    </div>
  );
}
